(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cb-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (window.customElements && !window.customElements.get('cb-bundle-offer')) {
    window.customElements.define(
      'cb-bundle-offer',
      class extends HTMLElement {
        connectedCallback() {
          this.onChange = this.onChange.bind(this);
          this.onQty = this.onQty.bind(this);
          this.onSelect = this.onSelect.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
          this.touched = false;
          this.addEventListener('change', this.onChange);
          document.addEventListener('quantity-selector:update', this.onQty);
          document.addEventListener('shopify:product:select', this.onSelect);
          // Window capture runs before Horizon's document-level submit handler, so a mixed
          // pack can take over Add to cart (the sticky bar clicks the same button).
          window.addEventListener('submit', this.onSubmit, true);

          this.paintDots();
          var pre = parseInt(this.dataset.preselect, 10) || 1;
          var checked = this.querySelector('.cb-bo__input:checked');
          var input = this.qtyInput();
          var current = input ? parseInt(input.value, 10) || 1 : 1;
          if (pre > 1 && checked && current === 1) {
            // Preselected bundle: push its quantity into the selector once on load.
            this.apply(parseInt(checked.value, 10) || 1);
          } else {
            this.mark(current);
          }
          // The Add to cart button sits below this block; sync again once it exists.
          var self = this;
          setTimeout(function () {
            self.syncAtc();
          }, 0);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          document.removeEventListener('quantity-selector:update', this.onQty);
          document.removeEventListener('shopify:product:select', this.onSelect);
          window.removeEventListener('submit', this.onSubmit, true);
        }

        // Horizon redraws the Add to cart button and the sticky bar after a variant change;
        // put the total back, and move untouched picks to the newly selected color.
        onSelect(event) {
          var self = this;
          var done = function (result) {
            setTimeout(function () {
              var id = result && result.variant && result.variant.id;
              id = id ? String(id).split('/').pop() : self.formVariantId();
              if (id) {
                self.setUnitOne(id);
                self.setArt(id);
              }
              if (!self.touched && id) self.setAllPicks(id);
              self.syncAtc();
            }, 60);
          };
          if (event && event.promise && typeof event.promise.then === 'function') {
            event.promise.then(done, function () {
              done(null);
            });
          } else {
            done(null);
          }
        }

        // Show the selected bundle's real total inside the main Add to cart button.
        syncAtc() {
          this.syncMix();
          if (this.dataset.atcTotal !== 'true') return;
          var btn = this.scope().querySelector('product-form-component .button[id^="BuyButtons-ProductSubmitButton-"]');
          if (!btn) return;
          var tag = btn.querySelector('.cb-atc-total');
          var checked = this.querySelector('.cb-bo__input:checked');
          var total = checked ? checked.closest('.cb-bo__card').querySelector('.cb-bo__total') : null;
          if (!total || btn.disabled) {
            if (tag) tag.remove();
            return;
          }
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'cb-atc-total';
            var added = btn.querySelector('.add-to-cart__added');
            btn.insertBefore(tag, added || null);
          }
          tag.textContent = total.textContent.trim();
        }

        scope() {
          return this.closest('.shopify-section') || document;
        }

        selector() {
          return this.scope().querySelector('product-form-component quantity-selector-component') ||
            this.scope().querySelector('quantity-selector-component');
        }

        qtyInput() {
          var sel = this.selector();
          return sel ? sel.querySelector('input[name="quantity"]') : null;
        }

        formVariantId() {
          var id = this.scope().querySelector('product-form-component input[name="id"]');
          return id ? id.value : '';
        }

        onChange(event) {
          var target = event.target;
          if (target && target.classList && target.classList.contains('cb-bo__pick-select')) {
            this.touched = true;
            this.paintDots();
            this.syncMix();
            return;
          }
          if (target && target.classList && target.classList.contains('cb-bo__swatch-input')) {
            var unit = target.closest('[data-unit]');
            if (unit && unit.getAttribute('data-unit') === '1') {
              // Unit 1 is the product's color: sync every pack's unit 1, the art, the gallery.
              this.setUnitOne(target.value);
              this.setArt(target.value);
              if (!this.touched) this.setAllPicks(target.value);
              this.driveVariant(target.getAttribute('data-option'));
            } else {
              this.touched = true;
            }
            this.syncMix();
            return;
          }
          if (!target || target.type !== 'radio' || !target.classList.contains('cb-bo__input')) return;
          this.apply(parseInt(target.value, 10) || 1);
          var item = target.closest('.cb-bo__item');
          if (item && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            item.classList.remove('cb-bo__item--pop');
            void item.offsetWidth;
            item.classList.add('cb-bo__item--pop');
          }
        }

        apply(qty) {
          var sel = this.selector();
          if (sel && typeof sel.setValue === 'function') {
            sel.setValue(String(qty));
            if (typeof sel.onQuantityChange === 'function') sel.onQuantityChange();
            if (typeof sel.updateButtonStates === 'function') sel.updateButtonStates();
          } else {
            var input = this.qtyInput() || this.scope().querySelector('input[name="quantity"]');
            if (input) {
              input.value = String(qty);
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          this.mark(qty);
        }

        // Follow the + / - buttons, but only for this section's own selector.
        onQty(event) {
          if (!event.detail || event.detail.cartLine) return;
          var target = event.target;
          if (!(target instanceof Node) || !this.scope().contains(target)) return;
          this.mark(event.detail.quantity);
        }

        mark(qty) {
          this.querySelectorAll('.cb-bo__input').forEach(function (radio) {
            radio.checked = parseInt(radio.value, 10) === qty;
          });
          this.syncAtc();
        }

        /* ---------- Per-unit color picks ---------- */

        paintDots() {
          this.querySelectorAll('.cb-bo__pick').forEach(function (pick) {
            var select = pick.querySelector('select');
            var dot = pick.querySelector('.cb-bo__pick-dot');
            var opt = select && select.options[select.selectedIndex];
            var color = opt ? opt.getAttribute('data-color') : '';
            if (!dot) return;
            if (color) dot.style.setProperty('--cb-dot', color);
            else dot.removeAttribute('style');
          });
        }

        setAllPicks(id) {
          var changed = false;
          this.querySelectorAll('.cb-bo__pick-select').forEach(function (select) {
            var opt = select.querySelector('option[value="' + id + '"]');
            if (opt && !opt.disabled && select.value !== String(id)) {
              select.value = String(id);
              changed = true;
            }
          });
          if (changed) this.paintDots();
          this.querySelectorAll('[data-unit]:not([data-unit="1"]) .cb-bo__swatch-input[value="' + id + '"]').forEach(function (r) {
            if (!r.disabled) r.checked = true;
          });
        }

        // Every pack's unit 1 shows the product's current color.
        setUnitOne(id) {
          this.querySelectorAll('[data-unit="1"] .cb-bo__swatch-input[value="' + id + '"]').forEach(function (r) {
            if (!r.disabled) r.checked = true;
          });
        }

        // Card art follows unit 1's color (data-cb-art maps variant id to src/srcset).
        setArt(id) {
          this.querySelectorAll('.cb-bo__img[data-cb-art]').forEach(function (box) {
            var map;
            try {
              map = JSON.parse(box.getAttribute('data-cb-art') || '{}');
            } catch (e) {
              return;
            }
            var art = map[String(id)];
            var img = box.querySelector('img');
            if (!art || !img || img.getAttribute('src') === art.src) return;
            img.srcset = art.srcset;
            img.src = art.src;
          });
        }

        // Unit 1 changed: select the same color in Horizon's (hidden) picker so the gallery, URL,
        // price and form variant update exactly as if the shopper had used it.
        driveVariant(option) {
          if (!option) return;
          var picker = this.scope().querySelector('variant-picker');
          if (!picker) return;
          var radio = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (r) {
            return r.value === option;
          });
          if (radio) {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var select = picker.querySelector('select');
          if (select && select.value !== option) {
            select.value = option;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // The checked pack's picks, or [] when no pack with picks is selected.
        activePicks() {
          var checked = this.querySelector('.cb-bo__input:checked');
          var item = checked ? checked.closest('.cb-bo__item') : null;
          var tray = item ? item.querySelector('.cb-bo__picks') : null;
          if (!tray) return [];
          var input = this.qtyInput();
          var qty = parseInt(checked.value, 10) || 1;
          if (input && parseInt(input.value, 10) !== qty) return [];
          var units = tray.querySelectorAll('[data-unit]');
          if (units.length) {
            return Array.prototype.map.call(units, function (unit) {
              var r = unit.querySelector('.cb-bo__swatch-input:checked');
              return r ? { id: r.value, name: r.getAttribute('data-name') || '' } : null;
            }).filter(Boolean);
          }
          return Array.prototype.map.call(tray.querySelectorAll('.cb-bo__pick-select'), function (select) {
            var opt = select.options[select.selectedIndex];
            return { id: select.value, name: opt ? opt.getAttribute('data-name') : '' };
          });
        }

        // Cart lines for the picks, or null when the normal form already adds the same thing.
        mixLines() {
          var picks = this.activePicks();
          if (!picks.length) return null;
          var order = [];
          var byId = {};
          picks.forEach(function (pick) {
            var id = pick.id;
            if (!byId[id]) {
              byId[id] = { id: id, quantity: 0, name: pick.name };
              order.push(id);
            }
            byId[id].quantity += 1;
          });
          var lines = order.map(function (id) {
            return byId[id];
          });
          if (lines.length === 1 && String(lines[0].id) === String(this.formVariantId())) return null;
          return lines;
        }

        syncMix() {
          var lines = this.mixLines();
          var scope = this.scope();
          if (scope.classList) scope.classList.toggle('cb-bo-mixed', !!lines);
          this.syncSticky(lines);
        }

        onSubmit(event) {
          var form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.closest('product-form-component') || !this.scope().contains(form)) return;
          var lines = this.mixLines();
          if (!lines) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addLines(lines, form);
        }

        addLines(lines, form) {
          var self = this;
          var error = this.querySelector('.cb-bo__error');
          if (error) error.hidden = true;
          if (this.busy) return;
          this.busy = true;
          var plain = lines.map(function (l) {
            return { id: l.id, quantity: l.quantity };
          });
          var job;
          if (typeof window.cbAddLines === 'function') {
            job = window.cbAddLines(plain, form);
          } else {
            // No conversion layer on the page: add through the AJAX API, then show the cart.
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            job = fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: plain.map(function (l) {
                  return { id: Number(l.id), quantity: l.quantity };
                })
              })
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (res) {
                if (res && res.status) throw new Error(res.description || res.message || '');
                window.location.href = root + 'cart';
              });
          }
          Promise.resolve(job)
            .catch(function (err) {
              if (!error) return;
              error.textContent = (err && err.message) || 'Those colors could not be added. Please try again.';
              error.hidden = false;
            })
            .then(function () {
              self.busy = false;
            });
        }

        /* ---------- Sticky bar summary ---------- */

        syncSticky(lines) {
          var sticky = this.scope().querySelector('sticky-add-to-cart');
          if (!sticky) return;
          var checked = this.querySelector('.cb-bo__input:checked');
          var card = checked ? checked.closest('.cb-bo__card') : null;
          var qty = checked ? parseInt(checked.value, 10) || 1 : 1;
          var bundled = !!card && qty > 1;
          // Any pick that differs from the form (two colors, or one other color) is spelled out.
          var mixed = bundled && !!lines;
          var info = sticky.querySelector('.sticky-add-to-cart__info');
          var price = sticky.querySelector('.sticky-add-to-cart__price');
          var offer = info ? info.querySelector('.cb-sticky-offer') : null;
          var totalBox = sticky.querySelector('.cb-sticky-total');
          var total = card ? card.querySelector('.cb-bo__total') : null;

          sticky.classList.toggle('cb-sticky--bundled', bundled && !!total);
          sticky.classList.toggle('cb-sticky--mixed', mixed);

          // The button carries the current pack total: "Add to cart · $34.90".
          var btnText = sticky.querySelector('.sticky-add-to-cart__button .add-to-cart-text__content');
          if (btnText) {
            var btnTotal = btnText.querySelector('.cb-sticky-btn-total');
            if (total) {
              if (!btnTotal) {
                btnTotal = document.createElement('span');
                btnTotal.className = 'cb-sticky-btn-total';
                btnText.appendChild(btnTotal);
              }
              btnTotal.textContent = ' \u00b7 ' + total.textContent.trim();
            } else if (btnTotal) {
              btnTotal.remove();
            }
          }

          if (!bundled) {
            if (offer) offer.remove();
            if (totalBox) totalBox.remove();
            return;
          }

          if (info) {
            if (!offer) {
              offer = document.createElement('p');
              offer.className = 'cb-sticky-offer';
              info.appendChild(offer);
            }
            var text = card.getAttribute('data-cb-title') || '';
            if (mixed) {
              text += ': ' + lines.map(function (l) {
                return l.quantity + ' ' + l.name;
              }).join(', ');
            } else if (card.getAttribute('data-cb-save')) {
              text += ', save ' + card.getAttribute('data-cb-save');
            }
            offer.textContent = text;
          }

          if (!total || !price) {
            if (totalBox) totalBox.remove();
            return;
          }
          if (!totalBox) {
            totalBox = document.createElement('div');
            totalBox.className = 'cb-sticky-total';
            price.insertAdjacentElement('afterend', totalBox);
          }
          totalBox.innerHTML = '';
          var now = document.createElement('span');
          now.className = 'cb-sticky-total__now';
          now.textContent = total.textContent.trim();
          totalBox.appendChild(now);
          var regular = card.querySelector('.cb-bo__regular');
          if (regular) totalBox.appendChild(regular.cloneNode(true));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cb-launch-price"] && !Shopify.designMode) return;
  try {
    if (window.customElements && !window.customElements.get('cb-launch-price')) {
    window.customElements.define(
      'cb-launch-price',
      class extends HTMLElement {
        connectedCallback() {
          var d = this.dataset;
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.endDate || '');
          var t = /^(\d{1,2}):(\d{2})$/.exec(d.endTime || '');
          if (!m || !t) {
            this.endLaunch();
            return;
          }
          this.end = this.etToEpoch(+m[1], +m[2], +m[3], +t[1], +t[2]);
          this.tick = this.tick.bind(this);
          this.tick();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }

        // Launch over: the row style keeps the price and drops the struck price and pill;
        // the other styles hide entirely.
        endLaunch() {
          if (this.classList.contains('cb-launch--row')) {
            this.querySelectorAll('[data-cb-launch-extra]').forEach(function (el) {
              el.hidden = true;
            });
          } else {
            this.hidden = true;
          }
        }

        // Wall-clock time in America/New_York to an epoch, DST-aware.
        etToEpoch(y, mo, da, h, mi) {
          var fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: 'numeric',
            day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
          });
          var offsetAt = function (ms) {
            var p = {};
            fmt.formatToParts(new Date(ms)).forEach(function (x) { if (x.type !== 'literal') p[x.type] = +x.value; });
            if (p.hour === 24) p.hour = 0;
            return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
          };
          var guess = Date.UTC(y, mo - 1, da, h, mi, 0);
          var o1 = offsetAt(guess);
          var o2 = offsetAt(guess - o1);
          return guess - (o1 === o2 ? o1 : o2);
        }

        tick() {
          clearTimeout(this.timer);
          var left = this.end - Date.now();
          if (!(left > 0)) {
            this.endLaunch();
            return;
          }
          var mins = Math.ceil(left / 60000);
          var days = Math.floor(mins / 1440);
          var hours = Math.floor((mins % 1440) / 60);
          var m = mins % 60;
          var text = days > 0 ? days + 'd ' + hours + 'h' : hours > 0 ? hours + 'h ' + m + 'm' : m + 'm';
          var out = this.querySelector('[data-cb-left]');
          if (out) out.textContent = text;
          this.timer = setTimeout(this.tick, Math.min(30000, Math.max(1000, left % 60000 || 60000)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    if (window.customElements && !window.customElements.get('cb-delivery-countdown')) {
    // CORE START (pure date math; also unit-tested outside the browser)
    var CB_DAY = 86400000;
    var cbFormatters = {};

    // Wall-clock parts of an instant in an IANA time zone.
    var cbParts = function (ms, tz) {
      var f = cbFormatters[tz];
      if (!f) {
        f = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        });
        cbFormatters[tz] = f;
      }
      var out = {};
      f.formatToParts(new Date(ms)).forEach(function (p) {
        if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
      });
      if (out.hour === 24) out.hour = 0;
      return out;
    };

    // Offset (ms) between wall-clock time in tz and UTC at a given instant.
    var cbOffset = function (ms, tz) {
      var t = Math.floor(ms / 1000) * 1000;
      var p = cbParts(t, tz);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - t;
    };

    // Instant (epoch ms) of a wall-clock time in tz. Two passes handle DST changes.
    var cbZonedToEpoch = function (y, m, d, h, mi, tz) {
      var guess = Date.UTC(y, m - 1, d, h, mi, 0);
      var off = cbOffset(guess, tz);
      var t = guess - off;
      var off2 = cbOffset(t, tz);
      return off2 === off ? t : guess - off2;
    };

    // Calendar dates are whole day numbers (days since 1970-01-01).
    var cbDayNum = function (y, m, d) {
      return Math.round(Date.UTC(y, m - 1, d) / CB_DAY);
    };

    var cbIsBiz = function (dn, hol) {
      var wd = (((dn + 4) % 7) + 7) % 7; // 0 = Sunday, 6 = Saturday
      return wd !== 0 && wd !== 6 && !hol[dn];
    };

    var cbNextBiz = function (dn, hol) {
      for (var i = 0; i < 400; i++) {
        dn += 1;
        if (cbIsBiz(dn, hol)) return dn;
      }
      return dn;
    };

    var cbAddBiz = function (dn, n, hol) {
      for (var i = 0; n > 0 && i < 800; i++) {
        dn += 1;
        if (cbIsBiz(dn, hol)) n -= 1;
      }
      return dn;
    };

    var cbParseHolidays = function (text) {
      var hol = {};
      String(text || '')
        .split(/[\s,;]+/)
        .forEach(function (s) {
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
          if (m) hol[cbDayNum(+m[1], +m[2], +m[3])] = true;
        });
      return hol;
    };

    // c = { tz, cutH, cutM, procMin, procMax, transitMin, transitMax, hol }
    var cbCompute = function (now, c) {
      var p = cbParts(now, c.tz);
      var today = cbDayNum(p.year, p.month, p.day);
      var cut = cbZonedToEpoch(p.year, p.month, p.day, c.cutH, c.cutM, c.tz);
      var received = today;
      if (!(cbIsBiz(today, c.hol) && now < cut)) {
        received = cbNextBiz(today, c.hol);
        var r = new Date(received * CB_DAY);
        cut = cbZonedToEpoch(r.getUTCFullYear(), r.getUTCMonth() + 1, r.getUTCDate(), c.cutH, c.cutM, c.tz);
      }
      var ship = cbAddBiz(received, c.procMax, c.hol);
      return {
        deadline: cut,
        msLeft: cut - now,
        ship: ship,
        arriveMin: cbAddBiz(cbAddBiz(received, c.procMin, c.hol), c.transitMin, c.hol),
        arriveMax: cbAddBiz(ship, c.transitMax, c.hol)
      };
    };

    // Time left as "3h 12m" (or "12m" in the last hour). Rounded up, never below 1m.
    var cbLeft = function (ms) {
      var mins = Math.max(1, Math.ceil(ms / 60000));
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      return h > 0 ? h + 'h ' + m + 'm' : m + 'm';
    };
    // CORE END

    // Fill a template like "Order within {countdown}" without using innerHTML.
    var cbFill = function (el, tpl, values) {
      el.textContent = '';
      String(tpl || '')
        .split(/(\{[a-z_]+\})/)
        .forEach(function (piece) {
          if (!piece) return;
          var key = piece.charAt(0) === '{' ? piece.slice(1, -1) : null;
          if (key && Object.prototype.hasOwnProperty.call(values, key)) {
            var b = document.createElement('strong');
            b.textContent = values[key];
            el.appendChild(b);
          } else {
            el.appendChild(document.createTextNode(piece));
          }
        });
    };

    var cbInt = function (v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? fallback : n;
    };

    window.customElements.define(
      'cb-delivery-countdown',
      class extends HTMLElement {
        connectedCallback() {
          var d = this.dataset;
          var pMin = cbInt(d.procMin, 1);
          var pMax = cbInt(d.procMax, 3);
          var tMin = cbInt(d.transitMin, 2);
          var tMax = cbInt(d.transitMax, 5);
          this.cfg = {
            tz: d.timezone || 'America/New_York',
            cutH: cbInt(d.cutoffHour, 14),
            cutM: cbInt(d.cutoffMinute, 0),
            procMin: Math.min(pMin, pMax),
            procMax: Math.max(pMin, pMax),
            transitMin: Math.min(tMin, tMax),
            transitMax: Math.max(tMin, tMax),
            hol: cbParseHolidays(d.holidays),
            withinMs: cbInt(d.countdownWithin, 24) * 3600000,
            countdown: d.showCountdown === 'true',
            delivery: d.showDelivery === 'true',
            calendar: d.arriveMode === 'calendar',
            calMin: cbInt(d.calMin, 8),
            calMax: cbInt(d.calMax, 15)
          };
          var locale = d.locale || 'en-US';
          var isLong = d.dateStyle === 'long';
          try {
            this.dateFmt = new Intl.DateTimeFormat(locale, {
              timeZone: 'UTC',
              weekday: isLong ? 'long' : 'short',
              month: isLong ? 'long' : 'short',
              day: 'numeric'
            });
            this.timeFmt = new Intl.DateTimeFormat(locale, {
              timeZone: this.cfg.tz,
              hour: 'numeric',
              minute: '2-digit',
              timeZoneName: 'short'
            });
            this.shortFmt = new Intl.DateTimeFormat(locale, {
              timeZone: 'UTC',
              month: 'short',
              day: 'numeric'
            });
          } catch (e) {
            return; // Invalid locale or time zone: keep the static server-rendered text.
          }
          this.boundUpdate = this.update.bind(this);
          document.addEventListener('visibilitychange', this.boundUpdate);
          this.update();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.boundUpdate) document.removeEventListener('visibilitychange', this.boundUpdate);
        }

        update() {
          clearTimeout(this.timer);
          var r;
          try {
            r = cbCompute(Date.now(), this.cfg);
            if (this.cfg.calendar) {
              // Calendar mode: arrival = order date + N calendar days, as the shipping
              // policy states it. Never show an arrival date before the ship-by date.
              var cp = cbParts(Date.now(), this.cfg.tz);
              var orderDay = cbDayNum(cp.year, cp.month, cp.day);
              var cMin = Math.min(this.cfg.calMin, this.cfg.calMax);
              var cMax = Math.max(this.cfg.calMin, this.cfg.calMax);
              r.arriveMin = Math.max(orderDay + cMin, r.ship);
              r.arriveMax = Math.max(orderDay + cMax, r.arriveMin);
            }
          } catch (e) {
            return;
          }
          var self = this;
          var d = this.dataset;
          var fmt = function (dn) {
            return self.dateFmt.format(new Date(dn * CB_DAY));
          };
          var values = {
            countdown: cbLeft(r.msLeft),
            ship_date: fmt(r.ship),
            arrive_min: fmt(r.arriveMin),
            arrive_max: fmt(r.arriveMax),
            cutoff_time: this.timeFmt.format(new Date(r.deadline))
          };
          var ticking = this.cfg.countdown && r.msLeft <= this.cfg.withinMs;
          // Compact layout: "arrives Oct 14 to 21" (the month repeats only when it changes).
          var compactEl = this.querySelector('[data-cb-compact]');
          if (compactEl && d.tplCompact) {
            var dMin = new Date(r.arriveMin * CB_DAY);
            var dMax = new Date(r.arriveMax * CB_DAY);
            var range = self.shortFmt.format(dMin);
            if (r.arriveMax !== r.arriveMin) {
              range += ' to ' + (dMin.getUTCMonth() === dMax.getUTCMonth() ? String(dMax.getUTCDate()) : self.shortFmt.format(dMax));
            }
            cbFill(compactEl, d.tplCompact, {
              arrive_range: range,
              arrive_min: self.shortFmt.format(dMin),
              arrive_max: self.shortFmt.format(dMax),
              ship_date: self.shortFmt.format(new Date(r.ship * CB_DAY))
            });
          }
          var shipEl = this.querySelector('[data-cb-ship]');
          var arriveEl = this.querySelector('[data-cb-arrive]');
          if (shipEl) cbFill(shipEl, ticking ? d.tplCountdown : d.tplPlain, values);
          if (arriveEl && this.cfg.delivery) cbFill(arriveEl, d.tplDelivery, values);

          // Timeline layout: Ordered (today) > Ships (by date) > Arrives (date range).
          var tl = this.querySelector('.cb-dc__tl');
          if (tl) {
            var lead = this.querySelector('[data-cb-lead]');
            if (lead) lead.hidden = !ticking;
            var p = cbParts(Date.now(), this.cfg.tz);
            var sf = function (dn) {
              return self.shortFmt.format(new Date(dn * CB_DAY));
            };
            var tv = {
              today: sf(cbDayNum(p.year, p.month, p.day)),
              ship_date: sf(r.ship),
              arrive_min: sf(r.arriveMin),
              arrive_max: sf(r.arriveMax)
            };
            var pairs = [
              ['[data-cb-tl-order]', d.tplTlOrder],
              ['[data-cb-tl-ship]', d.tplTlShip],
              ['[data-cb-tl-arrive]', d.tplTlArrive]
            ];
            pairs.forEach(function (pair) {
              var el = self.querySelector(pair[0]);
              if (el && pair[1]) cbFill(el, pair[1], tv);
            });
          }
          this.setAttribute('data-ready', '');
          // Re-check every 30 seconds, and right after the cutoff passes.
          this.timer = setTimeout(this.boundUpdate, Math.max(1000, Math.min(30000, r.msLeft + 500)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
